export let GOAL_TYPE;

(function (GOAL_TYPE) {
  GOAL_TYPE["COST_PER_CONTACT_IN_LIFECYCLE"] = "cost_per_contact_lifecycle";
  GOAL_TYPE["FIRST_FORM_SUBMISSION"] = "contacts_first_form_submission";
  GOAL_TYPE["NUMBER_OF_CONTACTS_IN_LIFECYCLE"] = "contact_lifecycle";
  GOAL_TYPE["NUMBER_OF_NETWORK_CONVERSIONS"] = "number_of_network_conversions";
})(GOAL_TYPE || (GOAL_TYPE = {}));

export let GOAL_STATUS;

(function (GOAL_STATUS) {
  GOAL_STATUS["EXCEEDED"] = "exceeded";
  GOAL_STATUS["ACHIEVED"] = "achieved";
  GOAL_STATUS["MISSED"] = "missed";
  GOAL_STATUS["IN_PROGRESS"] = "in_progress";
  GOAL_STATUS["PENDING"] = "pending";
})(GOAL_STATUS || (GOAL_STATUS = {}));

export let GOAL_MILESTONE;

(function (GOAL_MILESTONE) {
  GOAL_MILESTONE["MONTHLY"] = "monthly";
  GOAL_MILESTONE["QUARTERLY"] = "quarterly";
  GOAL_MILESTONE["YEARLY"] = "yearly";
})(GOAL_MILESTONE || (GOAL_MILESTONE = {}));

export let GOAL_CATEGORY;

(function (GOAL_CATEGORY) {
  GOAL_CATEGORY["MARKETING"] = "marketing";
})(GOAL_CATEGORY || (GOAL_CATEGORY = {}));

export const DEFAULT_GOAL_NAME = '--';
export const NUM_GOAL_TARGETS_PER_PAGE_OPTIONS = [10, 25, 50];
export const AVERAGE_TIME_BASED_GOALS = [GOAL_TYPE.COST_PER_CONTACT_IN_LIFECYCLE];
export let GOAL_KPI_TRACKING_METHOD;

(function (GOAL_KPI_TRACKING_METHOD) {
  GOAL_KPI_TRACKING_METHOD["HIGHER_IS_BETTER"] = "HIGHER_IS_BETTER";
  GOAL_KPI_TRACKING_METHOD["LOWER_IS_BETTER"] = "LOWER_IS_BETTER";
})(GOAL_KPI_TRACKING_METHOD || (GOAL_KPI_TRACKING_METHOD = {}));

export const GOAL_AGGREGATION_TYPES = {
  AVERAGE: 'AVG',
  COUNT: 'COUNT',
  MAX: 'MAX',
  MIN: 'MIN',
  SUM: 'SUM'
};
export const LOADING_PERCENTAGE_60 = 60;
export let COLUMN_NAME;

(function (COLUMN_NAME) {
  COLUMN_NAME["GOAL_NAME"] = "goalName";
  COLUMN_NAME["PROGRESS"] = "progress";
  COLUMN_NAME["DURATION"] = "duration";
  COLUMN_NAME["STATUS"] = "status";
  COLUMN_NAME["AD_CAMPAIGNS"] = "adCampaigns";
})(COLUMN_NAME || (COLUMN_NAME = {}));

export let SORT_DIRECTION;

(function (SORT_DIRECTION) {
  SORT_DIRECTION["ASC"] = "ASC";
  SORT_DIRECTION["DESC"] = "DESC";
})(SORT_DIRECTION || (SORT_DIRECTION = {}));

export const DEFAULT_GOAL_REQUEST_SORTS = [{
  property: 'hs_end_datetime',
  order: SORT_DIRECTION.DESC
}, {
  property: 'hs_kpi_progress_percent',
  order: SORT_DIRECTION.DESC
}, {
  property: 'hs_assignee_user_id',
  order: SORT_DIRECTION.ASC
}, {
  property: 'hs_assignee_team_id',
  order: SORT_DIRECTION.ASC
}, {
  property: 'hs_goal_name',
  order: SORT_DIRECTION.ASC
}];
export const GOAL_STATUS_TO_UI_TAG_COLOR = {
  [GOAL_STATUS.EXCEEDED]: 'calypso',
  [GOAL_STATUS.ACHIEVED]: 'success',
  [GOAL_STATUS.MISSED]: 'danger',
  [GOAL_STATUS.IN_PROGRESS]: 'default',
  [GOAL_STATUS.PENDING]: 'thunderdome'
};